import React from 'react';
import { MediaClientContext } from './MediaClientProvider';
import { MediaContext } from './MediaProvider';
export var useMediaClient = function useMediaClient() {
  var mediaClient = React.useContext(MediaClientContext);
  var _ref = React.useContext(MediaContext) || {},
    altMediaClient = _ref.mediaClient;
  if (!mediaClient && !altMediaClient) {
    throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
  }
  // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
  return mediaClient || altMediaClient;
};